<template>
  <div>
    <v-radio-group
      v-model="selectedTextbook"
      hide-details
      row
    >
      <v-radio
        v-for="(textbook, index) in textbooks"
        :key="index"
        :label="textbook.text"
        :value="textbook.value"
        color="secondary"
      />
    </v-radio-group>
  </div>
</template>

<script>
export default {

  computed: {
    textbooks() {
      return this.$store.state.master.allPublishers;
    },

    selectedTextbook: {
      get() {
        return this.$store.state.conditions.selectedTextbook;
      },
      set(value) {
        this.$store.commit('conditions/setSelectedTextbook', {
          textBook: value
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.v-label
  font-weight bold
</style>
